;(function($){

    function Nfse() {
        var _    =  this;
        _.API    = $("#app_url").val() + "/api/";
        _.oNotas = $("input[name='nfse[]']");
        _.total_gross_value  = parseFloat(0);
        _.total_tax_value    = parseFloat(0);
        _.total_net_value    = parseFloat(0);
        _.not_transmitted_gross = parseFloat(0);
        _.transmitted_gross     = parseFloat(0);

        $.ajaxSetup({
          headers:{
            'Accept' : "application/json",
            'Authorization': "Bearer "+$('meta[name="app-token"]').attr('content'),
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
        });  

        $("input#nfseAll").on("change", function(e){
            $(this).is(':checked') ? _.checkAll() : _.UnCheckAll();
        });

        $("input[name='nfse[]']").on("change", function(e){

            if($("input[name='nfse[]']:checked").length == 0) {
                window.location.reload(true);
            }
            
            _.total(this, $(this).is(':checked'));
        });
        $("#btn-nfse-transmit").on("click", function(e){
            e.preventDefault();
            
            if ($("input[name='nfse[]']:checked").length > 0) {

                var noCancel = false;

                $("input[name='nfse[]']:checked").each(function( index, value) {
                    
                    if($(value).data('status') == 3) {
                        noCancel = true;                        
                    }
                });

                if(noCancel) {
                    swal({
                        type: 'warning',
                        title: 'Atenção!',
                        text: "Você não pode transmitir notas canceladas!",
                        showCancelButton: false,
                        confirmButtonColor: "#DD6B55",
                        confirmButtonText: "Fechar!",
                        closeOnConfirm: true
                    }); 
                }else {                  
                    _.transmit();
                }
            }else{

                swal({
                    title: "Atenção",
                    text: "Você não marcou os RPS que deseja transmitir!",
                    type: "warning",
                    showCancelButton: false,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Fechar!",
                    closeOnConfirm: true
                });
            }
        });

        $("#btn-nfse-monitor").on("click", function(e){
            e.preventDefault();

            if ($("input[name='nfse[]']:checked").length > 0) {
                _.monitor();
            }else{

                swal({
                    title: "Atenção",
                    text: "Você não marcou os RPS que deseja monitorar!",
                    type: "warning",
                    showCancelButton: false,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Fechar!",
                    closeOnConfirm: true
                });
            }           
        });

        $("#btn-nfse-cancel").on("click", function(e){
            e.preventDefault();

            if ($("input[name='nfse[]']:checked").length > 0) {

                var noCancel = false;
                var pendingReplacement = false;

                $("input[name='nfse[]']:checked").each(function( index, value) {

                    if($(value).data('status') != 1) {
                        noCancel = true;                        
                    }

                    if($(value).data('replacement-status') == 'pending') {
                        pendingReplacement = true;
                    }
                });

                if(pendingReplacement) {
                    swal({
                        type: 'info',
                        title: 'Substituição em andamento',
                        text: "Uma ou mais NFS-e selecionadas possuem substituição em processamento. Aguarde a confirmação do Ambiente Nacional.",
                        showCancelButton: false,
                        confirmButtonText: "Entendi"
                    });
                }else if(noCancel) {
                    swal({
                        type: 'warning',
                        title: 'Atenção!',
                        text: "Você só pode realizar cancelamento de RPS autorizados!",
                        showCancelButton: false,
                        confirmButtonColor: "#DD6B55",
                        confirmButtonText: "Fechar!",
                        closeOnConfirm: true
                    }); 
                }else {
                   _.askCancellationReason();
                }

            }else{

                swal({
                    title: "Atenção",
                    text: "Você não marcou os RPS que deseja cancelars!",
                    type: "warning",
                    showCancelButton: false,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Fechar!",
                    closeOnConfirm: true
                });
            }           
        });

        $(".btn-print-nfse").on("click", function(e){
            e.preventDefault();

            _.print($(this).data('id'));
        });

        $("#nfse-legend").on("click", function(e){
            e.preventDefault();

            swal({
              type: 'info',
              html:
                '<div style="text-align: left; max-width: 150px; margin: 0 auto;"><i class="fa fa-circle" style="color: #c33434;"></i> Não Transmitida </br>' +
                '<i class="fa fa-circle" style="color: #4db300;"></i> Autorizada </br>' +
                '<i class="fa fa-circle" style="color: #0b7789;"></i> Transmitida </br>' +
                '<i class="fa fa-circle" style="color: #b4b4b4;"></i> Cancelada </br>' +
                '<i class="fa fa-circle" style="color: #000000;"></i> Não Autorizada</div>',
              showCloseButton: true,
              showCancelButton: false,
              focusConfirm: false,
              confirmButtonColor: '#0b7789',
              confirmButtonText:
                'Fechar'
            });
        });
    };

    Nfse.prototype.checkAll = function() {
        var _ =  this;

        _.oNotas.each(function( index, value) {
           $(value).prop('checked', true);
        });
    };

    Nfse.prototype.UnCheckAll = function() {
        var _ =  this;

        _.oNotas.each(function( index, value) {
           $(value).prop('checked', false);
        });
    };

    Nfse.prototype.transmit = function() {
        var _    = this;
        var rps  = [];
        var data = new FormData();

        $("input[name='nfse[]']:checked").each(function( index, value) {
            rps.push($(value).val());
        }).promise().done(function () { 
                    
            swal({
                type: 'warning',
                title: 'Aguarde!',
                text: "Estamos transmitindo os RPS selecionados.",
                showCancelButton: false,
                showConfirmButton: false,
                allowOutsideClick: false,
                onBeforeOpen: function() {
                    swal.showLoading();
                }
            }); 

            data.append('rps', rps);  

            $.ajax({
                type: "POST",
                url: _.API + "nfse/transmitir",
                data: data,
                dataType: 'json',
                cache: false,
                processData: false, 
                contentType: false, 
                success: function(data)
                {
                    swal(
                      'Sucesso!',
                      data.message,
                      'success'
                    ).then(function() {
                      location.reload();
                    });                                        
                },
                error: function(response) {
                    var html = '';
                    var data = response.responseJSON;

                    $.each(data, function( index, value) {

                        $.each(value, function(i, v){
                            html += v + '';
                        });
                    });

                    swal({
                        title: "Error",
                        html: '<textarea style="width: 100%;" rows="10"> '+html+'</textarea>',
                        type: "warning",
                        showCancelButton: false,
                        confirmButtonColor: "#DD6B55",
                        confirmButtonText: "Fechar!",
                        closeOnConfirm: true
                    }).then(function() {
                      location.reload();
                    });
                }
            });
        });
    };

    Nfse.prototype.monitor = function() {
        var _    = this;
        var rps  = [];
        var data = new FormData();

        $("input[name='nfse[]']:checked").each(function( index, value) {
            rps.push($(value).val());
        }).promise().done(function () { 

            
            swal({
                type: 'warning',
                title: 'Aguarde!',
                text: "Estamos monitorando os RPS selecionados.",
                showCancelButton: false,
                showConfirmButton: false,
                allowOutsideClick: false,
                onBeforeOpen: function() {
                    swal.showLoading();
                }
            }); 

            data.append('rps', rps);  

            $.ajax({
                type: "POST",
                url: _.API + "nfse/monitorar",
                data: data,
                dataType: 'json',
                cache: false,
                processData: false, 
                contentType: false, 
                success: function(response)
                {
                    var html = '<table>'+
                       '<thead>'+
                            '<tr>'+
                                '<th>RPS</th>'+
                                '<th>Status</th>'+
                                '<th>Retorno</th>'+
                            '</tr>'+
                        '</thead>'+
                        '<tbody>';                                    
                               
                    var data = response;

                    $.each(data, function( index, value) {
                        html += '<tr>';
                        html += '<td>'+ index +'</td>';    
                        html += '<td>'+ value.status +'</td>';                                
                        html += '<td>';

                        if(Array.isArray(value.text)) {
                            
                            $.each(value.text, function(i, v){
                                if(value.length > 1) {
                                    html +='' +v[0]+',';
                                } else {
                                    html += ''+ v[0]+'';
                                }                                                      
                            });

                        }else {
                            html += ''+ value.text +'';
                        }

                        html += '</td></tr>';
                    });

                    html += '</tbody>'+
                        '</table>';

                    swal({
                        html: html,
                        showCancelButton: false,
                        confirmButtonColor: "#DD6B55",
                        confirmButtonText: "Fechar!",
                        closeOnConfirm: true
                    }).then(function() {
                      location.reload();
                    });                                     
                },
                error: function(response) {

                    var html = '';
                    var data = response.responseJSON;

                    $.each(data, function( index, value) {

                        $.each(value, function(i, v){
                            html += v + '';
                        });
                    });

                    swal({
                        title: "Error",
                        html: '<textarea style="width: 100%;" rows="10"> '+html+'</textarea>',
                        type: "warning",
                        showCancelButton: false,
                        confirmButtonColor: "#DD6B55",
                        confirmButtonText: "Fechar!",
                        closeOnConfirm: true
                    }).then(function() {
                      location.reload();
                    });
                }
            });
        });
    };

    Nfse.prototype.cancel = function() {
        var _    = this;
        var rps  = [];
        var data = new FormData();

        $("input[name='nfse[]']:checked").each(function( index, value) {
            rps.push($(value).val());
        }).promise().done(function () { 

            
            swal({
                type: 'warning',
                title: 'Aguarde!',
                text: "Estamos solicitando o cancelamento  dos RPS selecionados.",
                showCancelButton: false,
                showConfirmButton: false,
                allowOutsideClick: false,
                onBeforeOpen: function() {
                    swal.showLoading();
                }
            }); 

        data.append('rps', rps);
        data.append('codigo_motivo', _.cancellationCode);
        data.append('motivo', _.cancellationReason);

            $.ajax({
                type: "POST",
                url: _.API + "nfse/cancelar",
                data: data,
                dataType: 'json',
                cache: false,
                processData: false, 
                contentType: false, 
                success: function(response)
                {
                    swal({
                        type: 'success',
                        title: 'Sucesso!',
                        text: "Cancelamento enviado com sucesso.",
                        showCancelButton: false,
                        confirmButtonColor: "#DD6B55",
                        confirmButtonText: "Fechar!",
                        closeOnConfirm: true
                    }).then(function() {
                      location.reload();
                    });                              
                },
                error: function(response) {
                    var message = "Erro ao cancelar a NFS-e.";
                    var errors = response.responseJSON;

                    if(errors && errors.message) {
                        message = errors.message;
                    }else if(errors) {
                        $.each(errors, function(key, values) {
                            if($.isArray(values) && values.length > 0) {
                                message = values.join("\n");
                                return false;
                            }
                        });
                    }

                    swal({
                        title: "Erro",
                        text: message,
                        type: "warning",
                        showCancelButton: false,
                        confirmButtonColor: "#DD6B55",
                        confirmButtonText: "Fechar!",
                        closeOnConfirm: true
                    }).then(function() {
                      location.reload();
                    });
                }
            });
        });
    };

    Nfse.prototype.askCancellationReason = function() {
        var _ = this;

        swal({
            title: 'Motivo do cancelamento',
            input: 'select',
            inputOptions: {
                '1': 'Erro na emissão',
                '2': 'Serviço não prestado',
                '9': 'Outros'
            },
            inputPlaceholder: 'Selecione o motivo',
            showCancelButton: true,
            cancelButtonText: 'Voltar',
            confirmButtonText: 'Continuar',
            inputValidator: function(value) {
                return new Promise(function(resolve, reject) {
                    value ? resolve() : reject('Selecione um motivo.');
                });
            }
        }).then(function(code) {
            swal({
                title: 'Justificativa do cancelamento',
                input: 'textarea',
                inputPlaceholder: 'Informe uma justificativa com no mínimo 15 caracteres',
                showCancelButton: true,
                cancelButtonText: 'Voltar',
                confirmButtonText: 'Cancelar NFS-e',
                inputValidator: function(value) {
                    return new Promise(function(resolve, reject) {
                        value && value.trim().length >= 15
                            ? resolve()
                            : reject('A justificativa deve ter no mínimo 15 caracteres.');
                    });
                }
            }).then(function(reason) {
                _.cancellationCode = code;
                _.cancellationReason = reason.trim();
                _.cancel();
            });
        });
    };


    Nfse.prototype.print = function(id) {
        var _    = this;
        var data = new FormData();

        data.append('id', id);  

        $.ajax({
            type: "POST",
            url: _.API + "nfse/imprimir",
            data: data,
            dataType: 'json',
            cache: false,
            processData: false, 
            contentType: false, 
            success: function(response)
            { 
                window.open(response.url[0], '_blank');                                     
            },
            error: function(response) {

                swal({
                    title: "Error",
                    text: "Houve um erro ao consultar o RPS.",
                    type: "warning",
                    showCancelButton: false,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Fechar!",
                    closeOnConfirm: true
                });  
            }
        });
    };

    
    Nfse.prototype.checkAll = function() {
        var _ =  this;
        _.oNotas.each(function( index, value) {
           $(value).prop('checked', true);
           _.total(value, true);
        });
    };

    Nfse.prototype.UnCheckAll = function() {
        var _ =  this;

        _.oNotas.each(function( index, value) {
           $(value).prop('checked', false);
           window.location.reload(true);
        });
    };


    Nfse.prototype.formatMoney = function(value) {
        return parseFloat(value || 0).toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    };

    Nfse.prototype.total = function(item, isSum) {
        var _                    = this;
        var ntotal_gross_value   = 0;
        var ntotal_tax_value     = 0;
        var ntotal_net_value     = 0;
        var not_transmitted_gross = 0;
        var transmitted_gross     = 0;
        var gross_percentage      = 0;
        var net_percentage        = 0;
        var tax_percentage        = 0;
        var not_transmitted_percentage = 0;
        var transmitted_percentage = 0;
        var a_nfses              = [];

        if (isSum) {
            _.total_gross_value += parseFloat($(item).data('gross-total')) || 0;
            _.total_tax_value   += parseFloat($(item).data('tax-total')) || 0;
            _.total_net_value   += parseFloat($(item).data('net-total')) || 0;
            _.not_transmitted_gross += parseFloat($(item).data('not-transmitted-gross')) || 0;
            _.transmitted_gross     += parseFloat($(item).data('transmitted-gross')) || 0;
        } else {
            _.total_gross_value -= parseFloat($(item).data('gross-total')) || 0;
            _.total_tax_value   -= parseFloat($(item).data('tax-total')) || 0;
            _.total_net_value   -= parseFloat($(item).data('net-total')) || 0;
            _.not_transmitted_gross -= parseFloat($(item).data('not-transmitted-gross')) || 0;
            _.transmitted_gross     -= parseFloat($(item).data('transmitted-gross')) || 0;
        }

        gross_percentage = (_.total_gross_value > 0) ? 100 : 0;
        net_percentage   = (_.total_gross_value > 0) ? (_.total_net_value * 100) / _.total_gross_value : 0;
        tax_percentage   = (_.total_gross_value > 0) ? (_.total_tax_value * 100) / _.total_gross_value : 0;
        not_transmitted_percentage = (_.total_gross_value > 0) ? (_.not_transmitted_gross * 100) / _.total_gross_value : 0;
        transmitted_percentage = (_.total_gross_value > 0) ? (_.transmitted_gross * 100) / _.total_gross_value : 0;

        ntotal_gross_value = _.formatMoney(_.total_gross_value);
        ntotal_tax_value   = _.formatMoney(_.total_tax_value);
        ntotal_net_value   = _.formatMoney(_.total_net_value);
        not_transmitted_gross = _.formatMoney(_.not_transmitted_gross);
        transmitted_gross     = _.formatMoney(_.transmitted_gross);

        $(".title-total-gross-value").text('R$ ' + ntotal_gross_value);
        $(".title-total-net-value").text('R$ ' + ntotal_net_value);
        $(".title-total-tax-value").text('R$ ' + ntotal_tax_value);
        $(".title-total-value-paid").text('R$ ' + not_transmitted_gross);
        $(".title-total-value-open").text('R$ ' + transmitted_gross);
        $(".title-total-gross-percent").text(_.formatMoney(gross_percentage) + '%');
        $(".title-total-net-percent").text(_.formatMoney(net_percentage) + '%');
        $(".title-total-tax-percent").text(_.formatMoney(tax_percentage) + '%');
        $(".title-total-not-transmitted-percent").text(_.formatMoney(not_transmitted_percentage) + '%');
        $(".title-total-transmitted-percent").text(_.formatMoney(transmitted_percentage) + '%');

        $.each($("input[name='nfse[]']:checked"), function(idex, value) {
            a_nfses.push($(value).val());
        }); 

        $.each($("#links a"), function(idex, value) {
            var href  = new URL($(value).attr('href'));
            href.searchParams.set('a_nfses', a_nfses);
            $(value).attr('href', href);
        });        
    };

   	new Nfse();

}(jQuery));
